import { FormattedMessage } from "react-intl";

const UnlimitedCustomers = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.unlimitedCustomers.content.body"
                    defaultMessage="Up to 20,000 agents (licensed users) to work on requests from unlimited customers (unlicensed users)."
                />
            </p>
        </div>
    );
};

export default UnlimitedCustomers;
